// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"247":"Recommendations-RecommendationsContainer","873":"SavedSearch-Container-SavedSearchesContainer"}[chunkId] + "-" + {"247":"86572c5fc6a272a18428","873":"96f3d6b8e23613f3fa8c"}[chunkId] + ".css";
};